import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import {
    Button,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    TColorCode,
} from '../../../patterns';
import Progress from '../../../patterns/components/progress/progress';
import Chart from '../../../patterns/components/chart/chart';

export const OverviewHelpModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).teamResultsStore;
    const sampleChartData = [
        { 'name': 1, 'Selected Unit': 75, 'Comparison Unit': 60 },
        { 'name': 2, 'Selected Unit': 80, 'Comparison Unit': 80 },
        { 'name': 3, 'Selected Unit': 100, 'Comparison Unit': 100 },
        { 'name': 4, 'Selected Unit': 50, 'Comparison Unit': 50 },
        { 'name': 5, 'Selected Unit': 100, 'Comparison Unit': 100 },
    ];

    const chartConfigs = [
        {
            id: 'chart-1',
            lines: [{ key: 'Selected Unit', color: 'gray' as TColorCode , strokeWidth: 2, strokePattern: '12 8'}],
            explanation: store.label('dashboard.overview-help-modal.dotted-line-explained'),
        },
        {
            id: 'chart-3',
            lines: [{ key: 'Selected Unit', color: 'blue' as TColorCode, strokeWidth: 2 }],
            explanation: store.label('dashboard.overview-help-modal.blue-line-explained'),
        },
        {
            id: 'chart-4',
            areas: [
                {
                    key: 'Selected Unit',
                    color: 'greenPastel' as TColorCode,
                    lineColor: 'black' as TColorCode,
                    stroke: 1,
                    strokeWidth: 2,
                },
            ],
            lines: [{ key: 'Selected Unit', color: 'black' as TColorCode }],
            explanation: store.label('dashboard.overview-help-modal.black-line-explained'),
        },
    ];

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('dashboard.overview-help-modal.title')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">{store.label('dashboard.overview-help-modal.content')}</div>
                <Grid justify={['right-xs']} className={'modal__progress-bar'}>
                    <GridColumn width={['xs-5']}>
                        <Progress {...{
                            color: 'green',
                            icon: 'like',
                            percent: 75,
                            label: store.label('dashboard.overview.score', {score_percentage: '75'}),
                        }}
                        />
                    </GridColumn>
                    <GridColumn width={['xs-7']} className={'modal__progress-bar-text'}>
                        {store.label('dashboard.category-help-modal.content-score')}
                    </GridColumn>
                </Grid>
                <Grid justify={['right-xs']} className={'modal__progress-bar'}>
                    <GridColumn width={['xs-5']}>
                        <Progress {...{
                            color: 'blue',
                            icon: 'users',
                            percent: 67,
                            label: store.label('dashboard.overview.activity', {answers_percentage: '67'}),
                        }}
                        />
                    </GridColumn>
                    <GridColumn width={['xs-7']} className={'modal__progress-bar-text'}>
                        {store.label('dashboard.questions-help-modal.participation')}
                    </GridColumn>
                </Grid>
                {chartConfigs.map((config, index) => (
                    <Grid key={index} justify={['left-xs']} className={'modal__chart-text'}>
                        <GridColumn width={['xs-5']}>
                            <div className="modal-chart-container">
                                <div className="modal-chart-wrapper">
                                    <Chart
                                        id={config.id}
                                        data={sampleChartData}
                                        areas={config.areas}
                                        lines={config.lines}
                                        aspect={46 / 7}
                                        hideDots={true}
                                        hideGrid={true}
                                        hideXAxis={true}
                                        hideYAxis={true}
                                        showTooltip={false}
                                    />
                                </div>
                            </div>
                        </GridColumn>
                        <GridColumn width={['xs-7']}>
                            <div className="modal__progress-bar-text">
                                <p>{config.explanation}</p>
                            </div>
                        </GridColumn>
                    </Grid>
                ))}
                <div className="text">
                    <p className="modal__help-link-label">
                        <a href={'https://moticheck.com/kb/'} target={'_blank'} rel="noreferrer">{store.label('common.help-modal.content-help-text-label')}</a>
                    </p>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('common.modal.close')}/>
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
